export function getCurrentPermissions() {
  try {
    const permissions = JSON.parse(localStorage.getItem("x-permissions") || "[]");
    return Array.isArray(permissions) ? permissions.filter((item) => typeof item === "string") : [];
  } catch {
    return [];
  }
}

export function hasPermission(permission) {
  const permissions = getCurrentPermissions();
  if (permissions.includes(permission)) return true;
  return (permission === "users.view" && permissions.includes("users.manage")) ||
    (permission === "roles.view" && (
      permissions.includes("roles.manage") || permissions.includes("users.manage")
    ));
}
